import { PermissionService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { FeatureService } from '../feature/feature.service';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { PermissionConstants } from 'src/core/constants/permission-constant';

@Injectable({
  providedIn: 'root',
})
export class PrivacyService {
  constructor(
    private permissionService: PermissionService,
    private featureService: FeatureService
  ) {}

  hasUserPrivacyRequirements(): boolean {
    const featureEnabled = this.featureService.isEnabled(FeatureConstants.FeatureUserAnonymization);
    const hasPermission = this.permissionService.getGrantedPolicy(
      PermissionConstants.ViewAnonymizedUsers
    );

    return !featureEnabled || (featureEnabled && hasPermission);
  }
}
